import React from 'react';

export const renderIconElement = (icon) => {
  if (!icon) return null;
  if (typeof icon === 'string') {
    return <i className={icon} />;
  }
  return icon;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Dropdown/utils/dropdownHelpers.js